var chunkMapping = {
	"35": [
		111,
		205,
		312,
		559,
		568,
		652,
		655,
		848,
		1012,
		1126,
		1335,
		1517,
		1526,
		1930,
		2040,
		2111,
		2591,
		2710,
		2948,
		3160,
		3406,
		3492,
		3542,
		4381,
		4428,
		5075,
		5621,
		5665,
		5695,
		6155,
		6317,
		6404,
		6467,
		6765,
		6835,
		6968,
		7122,
		7576,
		7579,
		7596,
		7599,
		7693,
		8513,
		8618,
		8726,
		8804,
		9266,
		9267,
		9300,
		9381,
		9439
	],
	"381": [
		7381
	],
	"518": [
		828,
		2391,
		2777,
		3580,
		5620,
		5894,
		6744,
		8626,
		9518,
		9684
	],
	"707": [
		137,
		9283
	]
};
var idToExternalAndNameMapping = {
	"111": [
		"default",
		"./Badge",
		8359
	],
	"137": [
		"default",
		"./register",
		7883
	],
	"205": [
		"default",
		"./Drawer",
		8359
	],
	"312": [
		"default",
		"./SearchFilter",
		8359
	],
	"559": [
		"default",
		"./Page",
		8359
	],
	"568": [
		"default",
		"./FiltersGroup",
		8359
	],
	"652": [
		"default",
		"./icons/Copy",
		8359
	],
	"655": [
		"default",
		"./icons/GoogleSquare",
		8359
	],
	"828": [
		"default",
		"./UnboxingPageIntroduction",
		616
	],
	"848": [
		"default",
		"./Request",
		1441
	],
	"1012": [
		"default",
		"./Col",
		8359
	],
	"1126": [
		"default",
		"./StatusFilter",
		8359
	],
	"1335": [
		"default",
		"./Text",
		8359
	],
	"1517": [
		"default",
		"./InputNumber",
		8359
	],
	"1526": [
		"default",
		"./icons/FacebookSquare",
		8359
	],
	"1930": [
		"default",
		"./FiltersBar",
		8359
	],
	"2040": [
		"default",
		"./EmptyStateSearch",
		8359
	],
	"2111": [
		"default",
		"./icons/Info",
		8359
	],
	"2391": [
		"default",
		"./UnboxingPageHeader",
		616
	],
	"2591": [
		"default",
		"./Tooltip",
		8359
	],
	"2710": [
		"default",
		"./Row",
		8359
	],
	"2777": [
		"default",
		"./Image",
		8359
	],
	"2948": [
		"default",
		"./Card",
		8359
	],
	"3160": [
		"default",
		"./utils",
		1441
	],
	"3406": [
		"default",
		"./icons/Delete",
		8359
	],
	"3492": [
		"default",
		"./MultipleSelectFilter",
		8359
	],
	"3542": [
		"default",
		"./Table",
		8359
	],
	"3580": [
		"default",
		"./UnboxingPageBody",
		616
	],
	"4381": [
		"default",
		"./EmptyStateFilters",
		8359
	],
	"4428": [
		"default",
		"./Column",
		8359
	],
	"5075": [
		"default",
		"./RowContainer",
		8359
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		616
	],
	"5621": [
		"default",
		"./Popover",
		8359
	],
	"5665": [
		"default",
		"./Checkbox",
		8359
	],
	"5695": [
		"default",
		"./icons/Add",
		8359
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		616
	],
	"6155": [
		"default",
		"./StatusOption",
		8359
	],
	"6317": [
		"default",
		"./Modal",
		8359
	],
	"6404": [
		"default",
		"./EmptyStateData",
		8359
	],
	"6467": [
		"default",
		"./hooks",
		1441
	],
	"6744": [
		"default",
		"./UnboxingPage",
		616
	],
	"6765": [
		"default",
		"./Avatar",
		8359
	],
	"6835": [
		"default",
		"./DateRangeFilter",
		8359
	],
	"6968": [
		"default",
		"./Form",
		8359
	],
	"7122": [
		"default",
		"./Switch",
		8359
	],
	"7381": [
		"default",
		"./cWrapper",
		1441
	],
	"7576": [
		"default",
		"./Space",
		8359
	],
	"7579": [
		"default",
		"./RangePicker",
		8359
	],
	"7596": [
		"default",
		"./SelectCard",
		8359
	],
	"7599": [
		"default",
		"./notification",
		8359
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"8513": [
		"default",
		"./Icon",
		8359
	],
	"8618": [
		"default",
		"./Button",
		8359
	],
	"8626": [
		"default",
		"./icons/PeopleUnboxing",
		8359
	],
	"8726": [
		"default",
		"./Input",
		8359
	],
	"8804": [
		"default",
		"./InlineSegmentationBuilder",
		9864
	],
	"9266": [
		"default",
		"./Select",
		8359
	],
	"9267": [
		"default",
		"./icons/Edit",
		8359
	],
	"9283": [
		"default",
		"./unboxing-page",
		616
	],
	"9300": [
		"default",
		"./Alert",
		8359
	],
	"9381": [
		"default",
		"./FormItem",
		8359
	],
	"9439": [
		"default",
		"./icons/Plus",
		8359
	],
	"9518": [
		"default",
		"./UnboxingPageDocumentation",
		616
	],
	"9684": [
		"default",
		"./UnboxingPageCrossSelling",
		616
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}